
(() => {
  const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbyuaqQ_NpTthOTqnZmuwspqzlyrjCu77Zy_MVKa3eWbaZHcCRwzPZYPlWECRTGoxx6G/exec';

  function initQuote(wrapper) {
    if (wrapper.dataset.initialized === 'true') return;
    wrapper.dataset.initialized = 'true';

    const openBtn = wrapper.querySelector('[data-quote-open]');
    const modal = wrapper.querySelector('[data-quote-modal]');

    const dialog = wrapper.querySelector('[data-quote-dialog]');
    const closeBtn = wrapper.querySelector('[data-quote-close]');
    const form = wrapper.querySelector('[data-quote-form]');
    const skuField = wrapper.querySelector('[data-quote-sku]');
    const qtyField = wrapper.querySelector('[data-quote-qty]');
    const content = wrapper.querySelector('[data-quote-content]');
    const success = wrapper.querySelector('[data-quote-success]');
    const errorBox = wrapper.querySelector('[data-quote-error]');
    const submitBtn = wrapper.querySelector('[data-quote-submit]');

    const variants = JSON.parse(
      wrapper.querySelector('[data-quote-variants]').textContent
    );

    const product = JSON.parse(
      wrapper.querySelector('[data-quote-product]').textContent
    );
     if (modal && modal.parentElement !== document.body) {
  document.body.appendChild(modal);
}
    let previousFocus;
    let previousOverflow = '';
    let submitting = false;
    let lastSubmissionSucceeded = false;

    function getVariant() {
      const section = wrapper.closest('.shopify-section') || document;
      const productForm = section.querySelector('form[action*="/cart/add"]');

      const id =
        productForm?.querySelector('[name="id"]')?.value ||
        new URLSearchParams(location.search).get('variant');

      return variants.find(v => String(v.id) === String(id)) ||
        variants.find(v => String(v.id) === String(product.defaultVariantId)) ||
        variants[0];
    }

    function syncProduct() {
      const variant = getVariant();
      skuField.value = variant?.sku || '';

      const section = wrapper.closest('.shopify-section') || document;
      const productQty = section.querySelector(
        'form[action*="/cart/add"] [name="quantity"]'
      );

      qtyField.value = Math.max(
        1,
        parseInt(productQty?.value, 10) || 1
      );
    }

    function openModal() {
      if (submitting) return;

      // A new click after a successful request opens a fresh form.
      if (lastSubmissionSucceeded) {
        form.reset();
        success.hidden = true;
        content.hidden = false;
        lastSubmissionSucceeded = false;
      }

      errorBox.hidden = true;
      syncProduct();

     previousFocus = document.activeElement;
previousOverflow = document.body.style.overflow;

modal.hidden = false;

document.documentElement.classList.add('quote-modal-open');
document.body.classList.add('quote-modal-open');

// Focus the dialog without opening the mobile keyboard.
dialog.focus({ preventScroll: true });
    }

    function closeModal() {
      if (submitting) return;

      modal.hidden = true;
      document.body.style.overflow = previousOverflow;
      previousFocus?.focus?.();
    }

    openBtn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);

    modal.addEventListener('click', event => {
      if (event.target === modal) closeModal();
    });

    modal.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = [...dialog.querySelectorAll(
        'button:not([disabled]), input:not([type="hidden"]):not([disabled]), textarea:not([disabled])'
      )].filter(el => el.getClientRects().length);

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (submitting || !form.reportValidity()) return;

      submitting = true;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
      closeBtn.disabled = true;
      errorBox.hidden = true;

      const data = new URLSearchParams(new FormData(form));
      const variant = getVariant();

      data.set('sku', variant?.sku || skuField.value);
      data.set('product', product.title);
      data.set('productUrl', location.origin + product.url);

      try {
        // Apps Script does not provide a straightforward CORS
        // response for direct Shopify storefront requests.
        // no-cors permits sending but cannot verify delivery.
        await fetch(SCRIPT_URL, {
          method: 'POST',
          mode: 'no-cors',
          body: data
        });

        // Do not claim confirmed email delivery here.
        content.hidden = true;
        success.hidden = false;
        lastSubmissionSucceeded = true;

      } catch (error) {
        errorBox.hidden = false;
        console.error('Quote submission failed:', error);
      } finally {
        submitting = false;
        submitBtn.disabled = false;
        submitBtn.textContent = 'Submit Quote Request';
        closeBtn.disabled = false;
      }
    });
  }

  function initAllQuotes() {
    document.querySelectorAll('[data-quote-wrapper]')
      .forEach(initQuote);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllQuotes);
  } else {
    initAllQuotes();
  }

  document.addEventListener('shopify:section:load', initAllQuotes);
})();
